import { forwardRef } from 'react'
import { Dialog as MuiDialog, Slide } from '@mui/material'
import PropTypes from 'prop-types'

const Transition = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />)

Transition.displayName = 'Transition'

const Dialog = (props) => (
  <MuiDialog TransitionComponent={Transition} scroll="paper" fullWidth maxWidth="sm" {...props} />
)

Dialog.propTypes = {
  children: PropTypes.node,
}

export default Dialog
